import {
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputRightAddon,
  Select,
  Text,
} from '@chakra-ui/react'
import { Profile, UnitSystem } from '../../../../../types/FirestoreUser'

interface BasicInfoSectionProps {
  profile: Profile
  units: UnitSystem
  extraInfoRequired: boolean
  isMine: boolean
  isSaved: boolean
  onUpdate: (changes: Partial<Profile>) => void
  onUpdateUnitSystem: (unitSystem: UnitSystem) => void
}

const BasicInfoSection = ({
  profile,
  units,
  extraInfoRequired,
  isMine,
  isSaved,
  onUpdate,
  onUpdateUnitSystem,
}: BasicInfoSectionProps) => {
  return (
    <>
      <FormControl>
        <FormLabel>
          First Name{' '}
          <Text as='span' color='red.500'>
            *
          </Text>
        </FormLabel>
        <Input
          required
          autoComplete='given-name'
          defaultValue={profile.firstName || ''}
          isDisabled={isMine && isSaved}
          onChange={(e) => onUpdate({ firstName: e.target.value })}
        />
      </FormControl>

      <FormControl>
        <FormLabel>
          Last Name{' '}
          <Text as='span' color='red.500'>
            *
          </Text>
        </FormLabel>
        <Input
          required
          autoComplete='family-name'
          defaultValue={profile.lastName || ''}
          isDisabled={isMine && isSaved}
          onChange={(e) => onUpdate({ lastName: e.target.value })}
        />
      </FormControl>

      <FormControl>
        <FormLabel>
          Unit System{' '}
          <Text as='span' color='red.500'>
            *
          </Text>
        </FormLabel>
        <Select
          placeholder='Choose Unit System'
          defaultValue={units}
          onChange={(e) => onUpdateUnitSystem(e.target.value as UnitSystem)}
        >
          <option value='imperial'>USA / Imperial</option>
          <option value='metric'>Metric</option>
        </Select>
      </FormControl>

      <FormControl>
        <FormLabel>
          Height{' '}
          {extraInfoRequired && (
            <Text as='span' color='red.500'>
              *
            </Text>
          )}
        </FormLabel>
        <InputGroup>
          <Input
            required={extraInfoRequired}
            defaultValue={profile.height || ''}
            onChange={(e) => onUpdate({ height: e.target.value })}
          />
          <InputRightAddon>{units === 'metric' ? 'cm' : 'in'}</InputRightAddon>
        </InputGroup>
      </FormControl>
    </>
  )
}

export default BasicInfoSection
